<div class="layout-shell">
  <app-sidebar />
  <div class="layout-main">
    <app-header />
    <main class="layout-content">
      <router-outlet />
    </main>
  </div>
</div>
<app-toast />
